<div class="block-schedule__top">
    <ridango-ui-back-button>
        <a [routerLink]="'/schedule' | localize">{{ 'LOCAL_BTN_BACK' | translate }}</a>
    </ridango-ui-back-button>
    <h1>{{ 'SCHEDULE_ROUTE_TITLE' | translate }}</h1>
    <div innerHtml="{{ 'SCHEDULE_ROUTE_DESCRIPTION' | translate }}"></div>
</div>

<div class="block-tab-link-items">
    <a [routerLink]="'/schedule/search' | localize"
    class="flex-center btn btn--maximal btn--remove-radius btn--remove-shadows btn--big link--no-line link--no-hover">
        {{ 'SCHEDULE_SEARCH_LINK' | translate }}</a>
    <a [routerLink]="'/schedule/routes' | localize" aria-current="page"
        class="block-tab-link-items--active flex-center btn btn--maximal btn--remove-radius btn--big btn--remove-shadows
        link--no-line link--no-hover">
        {{ 'SCHEDULE_SCHEDULE_LINK' | translate }}</a>
</div>

<div class="block-schedule__bottom" [attr.aria-busy]="!(loading$ | async)">
    <ridango-ui-basic-loading-spinner *ngIf="loading$ | async" [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
    </ridango-ui-basic-loading-spinner>
    <ng-container *ngIf="!(loading$ | async)">
        <ul class="remove-bullets route-list" *ngFor="let type of types" role="menu">
            <li *ngFor="let id of routeIdsByType[type]" role="none">
                <a [routerLink]="['/schedule/routes', id, 'directions']  | localize" role="menuitem"
                    class="link link--no-line link--no-hover flex-center full-width min-height-60"
                    (keydown)="setFocusOnNextItem($event, routeIdsByType[type].length)" #listItem>
                    <span role="text" attr.aria-label="Bus {{ allRoutes[id].route_short_name }}"
                        class="flex-center route-list--number">
                        {{ allRoutes[id].route_short_name }}
                    </span>
                    <div class="flex flex1 position-relative min-height-50 padding-10">
                        <span class="flex1 margin-right-10 align-self-center" role="text">
                            {{ allRoutes[id].route_long_name }}
                        </span>
                        <span class="icon icon-arrow-right-link align-self-center"></span>
                        <div class="route-list--hr"></div>
                    </div>
                </a>
            </li>
        </ul>
    </ng-container>
</div>
